module.exports = __webpack_public_path__ + "static/media/drafts_empty.6897fe91.svg";